import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { VociPort } from './voci.port';
import { Voce, CreateVoceDto, UpdateVoceDto, VociQueryParams } from '../../models/voci.model';
import { PaginatedResponse } from '../../models/preventivi.model';
import { environment } from '../../../environments/environment';
import {TenantService} from '../tenant.service';

@Injectable()
export class VociHttpService extends VociPort {
  private http = inject(HttpClient);
  private tenantService = inject(TenantService);
  private base = `${environment.apiBaseUrl || ''}/${this.tenantService.tenant}/voci`;
  getList(queryParams?: VociQueryParams): Observable<PaginatedResponse<Voce>> {
    let params = new HttpParams();

    if (queryParams) {
      if (queryParams.descrizioneSearch) params = params.set('descrizioneSearch', queryParams.descrizioneSearch);
      if (queryParams.size != null) params = params.set('size', queryParams.size.toString());
      if (queryParams.offset != null) params = params.set('offset', queryParams.offset.toString());
    }

    return this.http.get<PaginatedResponse<Voce>>(`${this.base}/suggestions`, { params });
  }

  getById(id: number): Observable<Voce> {
    return this.http.get<Voce>(`${this.base}/${id}`);
  }

  getByCapitoloId(idCapitolo: number): Observable<Voce[]> {
    return this.http.get<Voce[]>(`${this.base}/getByCapitolo/${idCapitolo}`);
  }

  create(dto: CreateVoceDto): Observable<number> {
    return this.http.post<number>(this.base, dto);
  }

  update(id: number, dto: UpdateVoceDto): Observable<number> {
    return this.http.patch<number>(`${this.base}/${id}`, dto);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.base}/${id}`);
  }

  deleteSuggestion(id: number): Observable<void> {
    return this.http.post<void>(`${this.base}/${id}/stopSuggesting`, {});
  }
}
